var render = function render(_c,_vm){return (_vm.props.item.transactionStatusId !== 0 && !(_vm.props.item.transactionStatusId === 5 && _vm.props.item[_vm.props.value] === 0))?_c('div',{staticClass:"inline-flex justify-center items-center rounded-full px-4 py-1",class:{
    'bg-green-500 text-white': _vm.props.item[_vm.props.value] > 0,
    'bg-gray-200 text-gray-400': _vm.props.item[_vm.props.value] === 0 || !_vm.props.item[_vm.props.value]
  }},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'comment']}}),_c('div',{staticClass:"ml-1 text-xs"},[_vm._v(" "+_vm._s(_vm.props.item[_vm.props.value] || "0")+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }